import { client } from "../../api/clientAutotask"
import { client as portalClient} from "../../api/client"
import { getApiPayload } from "../../utils/getApiPayload"
export const fetchTicketById = async (id) => {

    const responseAreas = await portalClient.get("permissions/areas")
    if (responseAreas.data) {
        var siteList = `{"siteList":"${responseAreas.data.map(({ id }) => id).join(',')}"}`
        const apiPayload = getApiPayload('siteList', 'companyID', siteList)
        const parsed = JSON.parse(apiPayload)
        const updatedPayload = JSON.stringify({
            filter: [
                { op: 'and', items: [
                    { op: 'eq', field: 'id', value: String(id) },
                    ...(parsed.filter || [])
                ]}
            ]
        })
                
        var uri = "autotaskapi/tickets/query"
        var responseAutotask = await client.post(uri, updatedPayload)
        return responseAutotask.data
    } else {
        return []
    }
}